export default __webpack_public_path__ + "static/media/estrategia-linguagens-humanas.0c7437a6.jpg";